<template>
  <v-timeline-item
    color="purple"
    large
    icon="far fa-broom">
    <div class="title pt-3">Started a new cleaning session</div>
  </v-timeline-item>
</template>

<script>
export default {
  name: 'NewSession',
};
</script>

<style scoped>

</style>
